export default __webpack_public_path__ + "static/media/oval.f8fe9181.svg";